@if (!isMobile) {
    <p-table 
        #dt
        [columns]="visibleColumns"
        [value]="list"
        dataKey="id"
        [rowHover]="true"
        [rows]="50"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10, 25, 50, 100, 200]"
        [loading]="isLoading"
        [paginator]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [filterDelay]="500"
        [size]="'large'"
        stripedRows 
        sortField="name"
        selectionMode="single"    
        [globalFilterFields]='searchColumns'
        [dt]="tableDts"
        [scrollable]="true"
        scrollHeight="650px"
    >

        <ng-template #caption>
            <div class="d-flex">
                @if (baService.isBaAdmin()) {
                    <p-button 
                        icon="pi pi-plus"
                        label="Add Program" 
                        (click)="editProgram(null)" 
                        class="pr-1"
                    />
                }

                <p-multiselect 
                    class="pl-1"
                    display="chip" 
                    [options]="availableColumns" 
                    [(ngModel)]="visibleColumns" 
                    optionLabel="header" 
                    selectedItemsLabel="Show / Hide" 
                    [style]="{ 'min-width': '100px' }" 
                    placeholder="Choose Columns" 
                    (ngModelChange)='columnChange($event)'
                />

                <p-button 
                    class="pl-1"
                    (click)="opp.toggle($event)" 
                    icon="pi pi-search" 
                    label="Filters" 
                    severity="warn"
                />
                <p-popover #opp>
                    <div>
                        <label class='for'>Is Active?</label>
                        <mat-button-toggle-group 
                            #isActiveFilter
                            [(ngModel)]="filters.isActive" 
                            [value]="filters.isActive"
                            (change)="
                                this.filters.isActive = $event.value; 
                                getList();
                            "
                        >
                            <mat-button-toggle 
                                class="flex-fill" 
                                [value]="true"
                            >Yes</mat-button-toggle>
                            <mat-button-toggle 
                                class="flex-fill mx-2" 
                                [value]="false"
                            >No</mat-button-toggle>
                            <mat-button-toggle 
                                class="flex-fill" 
                                value="null"
                            >All</mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>
                </p-popover>

                <p-iconfield 
                    iconPosition="right" 
                    class="ml-auto"
                >  
                    <p-inputicon>
                        <i class="pi pi-search pl-2"></i>
                    </p-inputicon>
                    <input 
                        #searchValue
                        pInputText 
                        type="text" 
                        (input)="dt.filterGlobal($event.target.value, 'contains')" 
                        placeholder="Search..." 
                    />
                    <p-button 
                        class="pl-1"
                        label="Clear" 
                        [outlined]="true" 
                        icon="pi pi-filter-slash" 
                        (click)="clearFilters(dt, searchValue)" 
                    />
                </p-iconfield>            
            </div>
        </ng-template>

        <ng-template 
            #header
            let-columns
        >
            <tr>
                @for (col of columns; track col; let i = $index) {
                    <th 
                        [pSortableColumn]="col?.canSort ? $safeNavigationMigration(col?.field) : null" 
                        [class]="col?.cellClass"
                    >
                        {{ col?.header }} 
                        @if (col?.canSort) { <p-sortIcon [field]="$safeNavigationMigration(col?.field)" /> }
                    </th>
                }
            </tr>
        </ng-template>

        <ng-template 
            #body 
            let-row
            let-columns="columns"
        >
            <tr 
                [pSelectableRow]="row" 
                (click)="editProgram(row)"
            >
                @for (col of columns; track col) {
                    <td [class]="col?.cellClass">
                        @if (col?.field == "canDelete") {
                            @if (row.canDelete) {
                                <p-button 
                                    icon="pi pi-trash"
                                    (click)="
                                        $event.stopPropagation(); 
                                        deleteProgram(row.id);
                                    " 
                                    severity="danger" 
                                /> 
                            }
                        } @else { {{ row[col?.field] }} }
                    </td>
                }
            </tr>
        </ng-template>

        <ng-template #emptymessage>
            <tr>
                <td 
                    colspan="3" 
                    class="text-center"
                >No records found.</td>
            </tr>
        </ng-template>
    </p-table>
} @else {
    <div class="d-flex mb-2 pl-3 pr-3">
        @if (baService.isBaAdmin()) {
            <p-button 
                icon="pi pi-plus"
                label="" 
                (click)="editProgram(null)" 
            />
        }

        <p-button 
            class="pl-1"
            (click)="opp.toggle($event)" 
            icon="pi pi-search" 
            label="" 
            severity="warn"
        />
        <p-popover #opp>
            <div>
                <label class='for'>Is Active?</label>
                <mat-button-toggle-group 
                    #isActiveFilter
                    [(ngModel)]="filters.isActive" 
                    [value]="filters.isActive"
                    (change)="
                        filters.isActive = $event.value; 
                        getList();
                    "
                >
                    <mat-button-toggle 
                        class="flex-fill" 
                        [value]="true"
                    >Yes</mat-button-toggle>
                    <mat-button-toggle 
                        class="flex-fill mx-2" 
                        [value]="false"
                    >No</mat-button-toggle>
                    <mat-button-toggle 
                        class="flex-fill" 
                        value="null"
                    >All</mat-button-toggle>
                </mat-button-toggle-group>
            </div>
        </p-popover>
    </div>

    @if (list?.length == 0) { <div class="text-center">No Records</div> }

    @for (row of list; track row) {
        <div class="mb-4 flex items-center justify-center">
            <p-card class="p-card pl-3 pr-3">
                <ng-template #header>
                    <div class="pb-2 p-card-header">
                        <h3 class="text-center">{{ row.name }}</h3>
                    </div>
                </ng-template>

                <div>
                    <div class="row pb-1">
                        <div class="col-md-6 text-left">Is Active:</div>
                        <div class="col-md-6 text-right">{{ row.isActiveStr }}</div>
                    </div>
                </div>

                <ng-template #footer>
                    <div class="row">
                        <div class="col-md-6 text-left">
                            <p-button 
                                icon="pi pi-external-link"
                                label="Edit" 
                                severity="info" 
                                (click)="
                                    $event.stopPropagation(); 
                                    editProgram(row);
                                "
                            />
                        </div>

                        <div class="col-md-6 text-right">
                            @if (row.canDelete) {
                                <p-button 
                                    icon="pi pi-trash"
                                    label="Delete" 
                                    severity="danger" 
                                    (click)="
                                        $event.stopPropagation();
                                        deleteProgram(row.id);
                                    "
                                />
                            }
                        </div>
                    </div>
                </ng-template>
            </p-card>
        </div>
    }
}

<ng-template 
    #modalProgram 
    let-modal
>
    <form
		[formGroup]="formGroup"
		(submit)='saveProgram(modal, formGroup)'
    >
        <div class="modal-header text-light d-flex bg-nav">
			<h5 class="modal-title col-md-7">{{ formGroup?.get('id').value !== 0 ? "Edit" : "New" }} B&A Program</h5>
			<button 
				type="button" 
				class="close text-light" 
				aria-label="Close" 
				(click)="modal.dismiss();"
			>
				<span aria-hidden="true">&times;</span>
			</button>
		</div>

        <div class="modal-body">
            <input type='hidden' formControlName='id' />

            <div class="row">
                <pcg-control-group 
                    class="col-md-12" 
                    label="Name"
                >
                    <input 
                        pcgControlRef 
                        formControlName="name" 
                        class="form-control" 
                        type="text" 
                        maxlength="150"
                    />
                </pcg-control-group>
            </div>

            @if (formGroup.controls.id.value > 0) {
                <div class="row">
                    <div class="col-md-12 text-left">
                        <p 
                            class="mt-2" 
                            [class.text-danger]="!formGroup.controls.isActive.value" 
                            [class.d-none]="formGroup.controls.isActive.value"
                        >This Program is deactivated.</p>
                        <a
                            [class.btn-outline-danger]="formGroup.controls.isActive.value"
                            [class.btn-outline-success]="!formGroup.controls.isActive.value"
                            class="btn btn-md ml-2"
                            (click)="toggleIsActive(modal, formGroup.controls.id.value)"
                        >{{ formGroup.controls.isActive.value ? 'Deactivate' : 'Activate' }}</a>
                    </div>
                </div>
            } @else {
                <input type='hidden' formControlName='isActive' />
            }
        </div>

        <div class="modal-footer">
            <button 
                type='button' 
                class="btn btn-cancel btn-lg" 
                (click)="modal.dismiss()"
            >Cancel</button>
            <button 
                type='submit' 
                class="btn btn-save btn-lg"
            >{{ this.formGroup.controls["id"].value === 0 ? "Create" : "Save" }}</button>
        </div>
    </form>
</ng-template>